export default {
	errors: {
		write_rejected:
			"Modification refusée : vous n'avez pas les droits sur cet élément. Rechargez la page ou contactez le support."
	},
	form: {
		required_error: 'Ce champ est obligatoire',
		max_length_exceeded_error:
			'Ce champ est trop long ({{length}} caractères maximum)'
	},
	legal: {
		copyright: 'Gerositus Sàrl - Tous droits réservés',
		i_consent: "J'accepte",
		agreement_title: 'Accord',
		agreement_content:
			'En utilisant Gerositus, vous acceptez nos <1>Conditions générales</1> et notre <2>Politique de confidentialité</2>.',
		agreement_terms_conditions: 'Conditions générales',
		agreement_privacy_policy: 'Politique de confidentialité',
	},
	navigation: {
		home: 'Accueil'
	},
	yes: 'Oui',
	no: 'Non',
	not_defined: 'Non défini',
	please_wait: 'Veuillez patienter',
	search: 'Rechercher',
	upgrade_required: 'Mise à niveau requise',
	create_project_title: 'Que souhaitez-vous accomplir ?',
	click_to_change: 'Cliquer pour modifier',
	click_to_create_one: 'Cliquez <button>pour en créer un</button>',
	no_goal: "Pas d'objectif",

	auth: {
		token_expiring_soon: 'Votre session expirera dans {{minutes}} minutes',
		token_expired:
			'Votre session a expiré. Vous serez redirigé vers la page de connexion.',
		token_check_error: 'Erreur lors de la vérification du token',
		session_expiring:
			'Votre session va bientôt expirer. Veuillez vous reconnecter. Temps restant : {{time}}'
	},
	bot: {
		placeholder: 'Entrez votre question ici',
		security_notice: 'IA privée, cloisonnée. Vos échanges restent confidentiels.'
	},
	tutorial: {
		button: 'Tutoriel',
		exit_title: 'Quitter le tutoriel',
		exit_confirm: 'Êtes-vous sûr de vouloir quitter le tutoriel ?'
	},
	subscription: {
		billing_monthly: 'Mensuel',
		billing_yearly: 'Annuel',
		billing_yearly_save: '(économisez 20%)',
		choose_now: 'Choisir'
	},
	icons: {
		used: 'Utilisés',
		unused: 'Non utilisés'
	},
	theme: {
		selector: 'Sélecteur de thème',
		current_theme: 'Thème actuel',
		change_theme: 'Changer de thème'
	},
	no_description: 'Aucune description',
	situation_analysis: {
		title: 'Analyse de situation',
		description:
			'Analysez automatiquement une organisation, entreprise ou situation',
		organization_label: 'Organisation/Entreprise',
		organization_placeholder: "Nom de l'organisation à analyser",
		subject_label: 'Sujet',
		subject_placeholder:
			'Sujet à analyser (prérempli avec le nom du projet)',
		launch_analysis: "Lancer l'analyse",
		analysis_in_progress: 'Analyse en cours...',
		complete_analysis: "Terminer l'analyse",
		waiting_analysis: "En attente de l'analyse...",
		waiting_summary: 'En attente de la synthèse...',
		waiting_stakes: 'En attente des enjeux...',
		waiting_risks: 'En attente des risques...',
		waiting_openings: 'En attente des ouvertures...',
		waiting_stakeholders: 'En attente des parties prenantes...',
		context_title: 'Contexte général',
		summary_title: 'Synthèse',
		stakes_title: 'Enjeux',
		risks_title: 'Risques',
		openings_title: 'Ouvertures',
		stakeholders_title: 'Parties prenantes',
		indicators_title: 'Indicateurs de succès',
		fishbone_title: 'Plan d\'action',
		status: 'Statut',
		likelihood: 'Probabilité',
		impact: 'Impact',
		stakeholder: {
			importance_label: 'Importance relative',
			propensity_label: 'Propension',
			engagement_label: 'Engagement',
			importance_values: {
				low: 'Faible',
				medium: 'Moyenne',
				high: 'Élevée'
			},
			propensity_values: {
				green: 'Favorable',
				neutral: 'Neutre',
				orange: 'Tendue',
				red: 'Adverse'
			},
			engagement_values: {
				inactive: 'Inactif',
				neutral: 'Neutre',
				low: 'Faible',
				medium: 'Moyen',
				high: 'Fort'
			},
			polarity_values: {
				positive: 'soutien',
				negative: 'opposition'
			}
		},
		risk_category_values: {
			operational: 'Opérationnel',
			strategic: 'Stratégique',
			existential: 'Existentiel'
		}
	},
	ai_disambiguation: {
		title: 'Vérification rapide du sujet',
		checking: "Vérification de la clarté du sujet avant de lancer l'analyse…",
		clear: 'Sujet clair, on lance.',
		fallback_question:
			"Le sujet peut s'interpréter de plusieurs façons. Choisissez celle qui correspond, ou ajoutez des précisions.",
		other_label: "Aucune ne correspond — j'apporte une précision ci-dessous",
		other_hint: "Renseignez les précisions, puis lancez l'analyse.",
		precisions_label: 'Ou ajoutez des précisions pour ré-évaluer',
		precisions_placeholder: 'Ex. : SaaS B2B sector-agnostic pour PME suisses…',
		recheck: 'Re-vérifier',
		confirm: "Lancer l'analyse"
	},
	ai_project_generation: {
		checkbox_label: 'Générer le contenu avec l\'IA',
		checkbox_tooltip: "Utilise le titre, la mission, la description et les scénarios listés ci-dessous. La recherche IA publique ne sera lancée qu’après votre validation (bouton « Créer le projet »).",
		title: 'Génération de projet assistée',
		go_to_project: 'Voir le projet',
		create_project: 'Créer le projet',
		include_in_project_aria: 'Inclure cet élément dans le projet',
		creation_modal_title: 'Création des éléments',
		creation_progress_text: '{{current}} / {{total}} éléments créés',
		error_title: 'Erreur lors de la génération',
		complete_title: 'Génération terminée',
		complete_description: 'Votre projet a été enrichi avec succès. L\'IA a identifié les parties prenantes, enjeux, risques et ouvertures clés.',
		summary_title: 'Synthèse de l\'analyse',
		initializing_text:
			'Préparation de l\'analyse approfondie… Cela peut prendre 6 à 10 minutes.',
		include_in_project_tooltip:
			'Si la case est cochée, l\'élément sera créé dans le projet lorsque vous cliquerez sur « Créer le projet ».',
		language_code: 'fr',
		patience_with_scenarios:
			"La génération des scénarios est complexe et peut prendre quelques minutes. Merci pour votre patience.",
		patience_no_scenarios:
			"L'analyse approfondie peut prendre quelques minutes. Merci pour votre patience.",
		phases: {
			initializing: 'Lancement',
			deep_research: 'Recherche',
			analyzing: 'Analyse IA',
			stakeholders: 'Parties prenantes',
			stakes: 'Enjeux',
			risks: 'Risques',
			openings: 'Ouvertures',
			summary: 'Synthèse',
			fishbone: 'Plan d\'action',
			entities: 'Entités',
			scenarios: 'Scénarios',
			indicators: 'Indicateurs',
			completed: 'Terminé',
			error: 'Erreur'
			},
		section_title: "Détails de la génération IA",
		disclosure_public_title: "Vers IA publiques",
		disclosure_public_sub: "Recherche web. Reçoit uniquement la prévisualisation neutre, reformulée à partir des champs renseignés ci-dessus — sans intention ni objectif.",
		disclosure_private_title: "IA privée et cloisonnée",
		disclosure_private_sub: "Exécutée dans un environnement isolé. Pas de réentraînement, aucune information transmise à l'extérieur. Traite le titre, la mission, la description et les scénarios.",
		zone_public: "Transmis à IA publique",
		zone_private: "Cloisonné — non transmis aux IA publiques",
		field_private_chip: "Privé & sécurisé",
		field_private_tooltip: "Traité par une IA privée, dans un environnement cloisonné. Pas de réentraînement, aucune information transmise à l'extérieur.",
		preview_title: "Prévisualisation de la recherche",
		preview_refresh: "Régénérer la prévisualisation",
		preview_hint: "Reformulation neutre de votre sujet, sans trace d'intention. C'est exactement ce qui sera transmis à la recherche publique — seulement après votre validation.",
		preview_placeholder: "Renseignez au moins le titre du projet pour générer la prévisualisation.",
		launch_generation: "Lancer la génération",
		fishbone_source: 'Texte source',
		scenario_n: 'Scénario {{n}}',
		scenario_optimistic: 'Favorable',
		scenario_baseline: 'Probable',
		scenario_pessimistic: 'Défavorable',
		scenario_pending: 'En attente',
		scenario_triggers: 'Événements déclencheurs',
		scenario_action_window: 'Fenêtre d\'action',
		scenario_detail: 'Analyse détaillée',
		dismiss: 'Ignorer les propositions IA et créer le projet',
		save_pdf: 'Sauvegarder en PDF',
		save_hint: 'Vous pouvez sauvegarder cette analyse avant de passer au projet.',
		scenario_impacts: 'Impacts par entit\u00e9',
		data: {
			scenarios: 'Scénarios',
			fishbone: 'Plan d\'action stratégique',
			indicators: 'Indicateurs de succès',
			strategic_context: 'Contexte stratégique'
		},
		strategic_context: {
			pestel_title: 'PESTEL — Lames de fond',
			porter_title: 'Porter — Contexte sectoriel',
			internal_title: 'Contexte interne',
			global_synthesis_title: 'Synthèse globale',
			verdict: 'Verdict',
			pestel_axis: {
				political: 'Politique',
				economic: 'Économique',
				social: 'Social',
				technological: 'Technologique',
				environmental: 'Environnemental',
				legal: 'Légal'
			},
			impact: {
				faible: 'Faible',
				modere: 'Modéré',
				fort: 'Fort'
			},
			porter_force: {
				rivalry: 'Rivalité sectorielle',
				newEntrants: 'Nouveaux entrants',
				substitutes: 'Substituts',
				suppliers: 'Pouvoir des fournisseurs',
				buyers: 'Pouvoir des clients'
			},
			scale: {
				difficult: 'Difficile',
				favorable: 'Favorable'
			},
			internal_component: {
				culture: 'Culture',
				resources: 'Ressources',
				governance: 'Gouvernance'
			},
			internal_verdict: {
				atout: 'Atout',
				fragilite: 'Fragilité'
			}
		},
		detail: {
			started: 'Démarrage de l\'analyse…',
			query_reformulated: 'Requête neutralisée — recherche en cours…',
			stakes_done: 'Enjeux extraits',
			risks_done: 'Risques extraits',
			openings_done: 'Ouvertures extraites',
			stakeholders_done: 'Parties prenantes extraites',
			summary_done: 'Synthèse rédigée',
			fishbone_done: 'Plan d\'action généré',
			structuring: 'Structuration des données…'
		}
	},
	scenario_elaboration: {
		title: 'Élaboration du scénario avec IA',
		hypothesis: 'Hypothèse',
		initializing: "Initialisation de l'analyse...",
		error_title: "Erreur lors de l'élaboration",
		complete_title: 'Élaboration terminée',
		complete_description:
			'Le scénario a été élaboré avec succès. Les modifications ont été appliquées.',
		analysis_preview: 'Analyse préliminaire',
		applied_changes: 'Modifications appliquées',
		stakeholders_modified: 'partie(s) prenante(s) modifiée(s)',
		stakes_modified: 'enjeu(x) modifié(s)',
		risks_modified: 'risque(s)/ouverture(s) modifié(s)',
		indicators_modified: 'contrainte(s) modifiée(s)',
		new_elements: 'nouveau(x)',
		steps: {
			started: 'Démarrage',
			started_desc: "Initialisation de l'analyse...",
			fetching_project: 'Récupération du projet',
			fetching_project_desc: 'Chargement des données du projet...',
			deep_research: 'Première analyse',
			deep_research_desc: 'Analyse situationnelle approfondie...',
			ai_analysis: 'Analyse IA',
			ai_analysis_desc: "L'IA analyse l'impact de l'hypothèse...",
			reformatting: 'Formatage',
			reformatting_desc: 'Structuration des résultats...',
			processing_stakeholders: 'Parties prenantes',
			processing_stakeholders_desc:
				'Calcul des impacts sur les parties prenantes...',
			processing_stakes: 'Enjeux',
			processing_stakes_desc: 'Calcul des impacts sur les enjeux...',
			processing_risks: 'Risques',
			processing_risks_desc: 'Calcul des impacts sur les risques...',
			processing_indicators: 'Indicateurs',
			processing_indicators_desc:
				'Calcul des impacts sur les indicateurs...',
			completed: 'Terminé',
			completed_desc: 'Analyse terminée avec succès',
			error: 'Erreur',
			error_desc: "Une erreur s'est produite"
		}
	},
	attachments: {
		title: 'Pièces jointes',
		privacy_chip: 'Privé & sécurisé',
		subtitle: "Documents privés (PDF, DOCX, TXT) lus par l'IA pour enrichir l'analyse. Chiffrés, scannés antivirus, jamais re-servis ni cités textuellement.",
		drop_hint: 'Déposez ou cliquez pour ajouter',
		formats_hint: 'PDF, DOCX, TXT · 50 MB max',
		empty: 'Aucun document',
		delete: 'Supprimer',
		submit_blocked: 'Attendez la fin du scan antivirus de toutes les pièces jointes avant de lancer.',
		ready_short: 'prêt',
		scanning_short: 'scan',
		count_one: '{{count}} fichier',
		count_other: '{{count}} fichiers',
		status: {
			pending: 'En attente',
			scanning: 'Scan antivirus',
			ready: 'Prêt',
			infected: 'Infecté',
			failed: 'Échec analyse'
		},
		error: {
			unsupported: 'Format non supporté',
			too_large: 'Fichier trop lourd (max 50 MB)',
			upload_failed: "Échec de l'upload",
			delete_failed: 'Suppression impossible'
		}
	}
};
